interface LocaleMap {
    [key: string]: SupportedLocale;
}

export enum SupportedLocale {
    bgBG = 'bg-BG',
    csCZ = 'cs-CZ',
    daDK = 'da-DK',
    elGR = 'el-GR',
    enGB = 'en-GB',
    esES = 'es-ES',
    etEE = 'et-EE',
    fiFI = 'fi-FI',
    frFR = 'fr-FR',
    hrHR = 'hr-HR',
    huHU = 'hu-HU',
    itIT = 'it-IT',
    koKR = 'ko-KR',
    ltLT = 'lt-LT',
    lvLV = 'lv-LV',
    nbNO = 'nb-NO',
    nlNL = 'nl-NL',
    plPL = 'pl-PL',
    ptBR = 'pt-BR',
    ptPT = 'pt-PT',
    roRO = 'ro-RO',
    skSK = 'sk-SK',
    slSI = 'sl-SI',
    svSE = 'sv-SE',
    deDE = 'de-DE',
}

const DEFAULT_LOCALE = SupportedLocale.enGB;

const supportedLocaleMap: LocaleMap = {
    ...Object.fromEntries(Object.values(SupportedLocale).map((locale) => [locale, locale])),
    bg: SupportedLocale.bgBG,
    cs: SupportedLocale.csCZ,
    da: SupportedLocale.daDK,
    el: SupportedLocale.elGR,
    es: SupportedLocale.esES,
    et: SupportedLocale.etEE,
    fi: SupportedLocale.fiFI,
    fr: SupportedLocale.frFR,
    hr: SupportedLocale.hrHR,
    hu: SupportedLocale.huHU,
    it: SupportedLocale.itIT,
    ko: SupportedLocale.koKR,
    lt: SupportedLocale.ltLT,
    lv: SupportedLocale.lvLV,
    nb: SupportedLocale.nbNO,
    nl: SupportedLocale.nlNL,
    pl: SupportedLocale.plPL,
    pt: SupportedLocale.ptPT,
    ro: SupportedLocale.roRO,
    sk: SupportedLocale.skSK,
    sl: SupportedLocale.slSI,
    sv: SupportedLocale.svSE,
    de: SupportedLocale.deDE,
};

const extractLanguage = (locale: string | null | undefined) => {
    return (locale ?? DEFAULT_LOCALE).split('-', 1)[0];
};

const DEFAULT_LANG = extractLanguage(DEFAULT_LOCALE);

const getSupportedLocale = (preferredLocale: string): SupportedLocale =>
    supportedLocaleMap[preferredLocale] ?? DEFAULT_LOCALE;

export { DEFAULT_LANG, DEFAULT_LOCALE, extractLanguage, supportedLocaleMap, getSupportedLocale };
